import { twMerge } from "tailwind-merge";

const Card = ({ children, className = "" }) => {
  const classes = twMerge(`bg-white rounded-lg p-5 shadow-lg ${className}`);
  return <section className={classes}>{children}</section>;
};

export default Card;
